import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _instanceof } from "@swc/helpers/_/_instanceof";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { endPoint } from "constants/server/api";
import { http } from "utils/http";
import { stockCountError } from "utils/stockCountError";
import { saveAs } from "file-saver";
export var exportStockCountExcel = createAsyncThunk("stockCount/exportExcel", function() {
    var _ref = _async_to_generator(function(param, param1) {
        var roundId, rejectWithValue, response, fileName, error, _error_response, data, _tmp, _tmp1, _, e;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    roundId = param.roundId, rejectWithValue = param1.rejectWithValue;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        8
                    ]);
                    return [
                        4,
                        http.post(endPoint.STOCK_COUNT_EXPORT_EXCEL, {
                            roundId: roundId
                        }, {
                            headers: {
                                Authorization: "Bearer ".concat(localStorage.getItem("accessToken"))
                            },
                            responseType: "blob",
                            timeout: 300000
                        })
                    ];
                case 2:
                    response = _state.sent();
                    fileName = "stock-count-".concat(roundId, ".xlsx");
                    saveAs(response.data, fileName);
                    return [
                        2,
                        {
                            fileName: fileName
                        }
                    ]; // เก็บ metadata เท่านั้น ไม่เก็บ binary ลง Redux
                case 3:
                    error = _state.sent();
                    data = error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.data;
                    if (!_instanceof(data, Blob)) return [
                        3,
                        7
                    ];
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        6,
                        ,
                        7
                    ]);
                    _tmp = {};
                    _tmp1 = {};
                    _ = JSON.parse;
                    return [
                        4,
                        data.text()
                    ];
                case 5:
                    return [
                        2,
                        rejectWithValue.apply(void 0, [
                            stockCountError.apply(void 0, [
                                (_tmp.response = (_tmp1.data = _.apply(JSON, [
                                    _state.sent()
                                ]), _tmp1), _tmp)
                            ])
                        ])
                    ];
                case 6:
                    e = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 7:
                    return [
                        2,
                        rejectWithValue(stockCountError(error))
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());
// ทุก endpoint ของโมดูลผ่าน thunk เพื่อเก็บ loading, response และ error ใน Redux
var request = function(operation, endpoint) {
    return createAsyncThunk("stockCount/".concat(operation), /*#__PURE__*/ _async_to_generator(function() {
        var payload, rejectWithValue, _result_data, result, _result_data_data, error;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    payload = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, rejectWithValue = (_arguments.length > 1 ? _arguments[1] : void 0).rejectWithValue;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        http.post(endpoint, payload, {
                            headers: {
                                Authorization: "Bearer ".concat(localStorage.getItem("accessToken"))
                            }
                        })
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        (_result_data_data = result === null || result === void 0 ? void 0 : (_result_data = result.data) === null || _result_data === void 0 ? void 0 : _result_data.data) !== null && _result_data_data !== void 0 ? _result_data_data : result === null || result === void 0 ? void 0 : result.data
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        rejectWithValue(stockCountError(error))
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }));
};
export var getStockCountRounds = request("list", endPoint.STOCK_COUNT_LIST);
export var createStockCountRound = request("create", endPoint.STOCK_COUNT_CREATE);
export var transitionStockCountRound = request("transition", endPoint.STOCK_COUNT_TRANSITION);
export var deleteStockCountRound = request("delete", endPoint.STOCK_COUNT_DELETE);
export var getStockCountItems = request("items", endPoint.STOCK_COUNT_ITEMS);
export var getStockCountProducts = request("products", endPoint.STOCK_COUNT_PRODUCTS);
export var getStockCountBrands = request("brands", endPoint.STOCK_COUNT_BRANDS);
export var addStockCountItem = request("addItem", endPoint.STOCK_COUNT_ADD_ITEM);
export var reduceStockCountItem = request("reduceItem", endPoint.STOCK_COUNT_REDUCE_ITEM);
export var cancelStockCountItem = request("cancelItem", endPoint.STOCK_COUNT_CANCEL_ITEM);
export var getStockCountLogs = request("logs", endPoint.STOCK_COUNT_LOGS);
